export const PROGRAM_CARDS_4_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_thumbnail_image: "",
    meta_thumbnail_image_alt: "Career thumbnail",
    meta_title: "Data Scientist",
    meta_salary: "₹12 LPA",
    meta_key_skills: "Python, Machine Learning, SQL, Statistics",
    meta_priority: 1,
    meta_status: true,
  },

  PROGRAM_CARDS_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "Title",
      value: "Careers After {This Course}",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title (wrap highlighted text in { } e.g., Careers After {This Course})",
      required: false,
      defaultValue: "Careers After {This Course}",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "title_highlight_color",
      label: "Title Highlight Color",
      value: "#E1473F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Color of the { } highlighted text (e.g., #E1473F)",
      required: false,
      defaultValue: "#E1473F",
    },
    {
      fieldName: "salary_text_color",
      label: "Average Salary Text Color",
      value: "#E1473F",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter average salary text color (e.g., #E1473F)",
      required: false,
      defaultValue: "#E1473F",
    },
    {
      fieldName: "key_skills_text_color",
      label: "Key Skills Text Color",
      value: "#171719",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter key skills chip text color (e.g., #171719)",
      required: false,
      defaultValue: "#171719",
    },
    {
      fieldName: "key_skills_background_color",
      label: "Key Skills Background Color",
      value: "#F3F4F6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter key skills chip background color (e.g., #F3F4F6)",
      required: false,
      defaultValue: "#F3F4F6",
    },
    {
      fieldName: "key_skills_border_color",
      label: "Key Skills Border Color",
      value: "#FF9944",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter key skills chip border color (e.g., #FF9944)",
      required: false,
      defaultValue: "#FF9944",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter the supporting description shown under the title",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "note",
      label: "Note",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter the italic note shown above the cards",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_image",
      label: "Background Image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload full-bleed background image (optional)",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "background_image_alt",
      label: "Background Image Alt Text",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Background Image Alt Text",
      required: false,
      defaultValue: "",
    },
    {
      fieldName: "status",
      label: "Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Program Cards Section",
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    {
      header: "Card Image",
      fieldName: "meta_thumbnail_image",
      value: "",
      valueType: "string",
      filedType: "FILE",
      placeholder: "Upload Card Image",
    },
    {
      header: "Card Image Alt Text",
      fieldName: "meta_thumbnail_image_alt",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Card Image Alt Text",
    },
    {
      header: "Title",
      fieldName: "meta_title",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Card Title (e.g., Data Scientist)",
    },
    {
      header: "Average Salary",
      fieldName: "meta_salary",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Average Salary (e.g., ₹12 LPA)",
    },
    {
      header: "Key Skills",
      fieldName: "meta_key_skills",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter comma-separated skills (e.g., Python, SQL, Statistics)",
    },
    {
      header: "Priority",
      fieldName: "meta_priority",
      value: "",
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter Priority",
      required: true,
    },
    {
      header: "Status",
      fieldName: "meta_status",
      value: "",
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enter Status",
    },
  ],
};
